module.exports = __webpack_public_path__ + "static/media/img_hand_shaking@3x.a692e65b.png";